import {RouteLocationRaw} from 'vue-router';

interface QueryTargetRoute {
    page?: 'login' | 'address' | string;
    [key: string]: any;
}

export function resolveQueryPageRoute(query: QueryTargetRoute): undefined | RouteLocationRaw {

    switch (query.page) {
        case 'login':
            return {
                name: 'tunnel.loginVerification',
                query
            }
        case 'address':
            return {
                name: 'tunnel.addressVerification',
                query
            }

        default:
            return undefined;
    }
}

/**
 * Returns the given redirect target only if it is a same-origin relative path ("/orders?id=1"),
 * otherwise null. Absolute URLs, protocol-relative ("//host") and backslash/whitespace tricks
 * ("/\host", "/\t/host") are rejected so a crafted targeturi cannot send the user off-site.
 */
export function getSafeTargetUri(value: unknown): string | null {

    if ('string' !== typeof value || !value.startsWith('/')) {
        return null;
    }

    if (/[\\\s\u0000-\u001f\u007f]/.test(value) || value.startsWith('//')) {
        return null;
    }

    try {
        const url: URL = new URL(value, window.location.origin);

        return url.origin === window.location.origin ? value : null;
    } catch (e) {
        return null;
    }
}

// Full page navigation (reloads the app), kept here so it can be mocked in tests
export function redirectTo(url: string): void {

    window.location.href = url;
}
